const modules = [
  {
    number: "01",
    title: "Futures Trading Fundamentals",
    desc: "Understand how futures markets work, key terminology, contract mechanics, and the role of futures in a diversified investment strategy.",
    topics: ["Market structure & mechanics", "Contract types & specifications", "Price discovery & liquidity", "Role of futures in portfolios"],
  },
  {
    number: "02",
    title: "Market Literacy & Analysis",
    desc: "Develop the ability to read, interpret, and analyze market data with confidence using both technical and fundamental frameworks.",
    topics: ["Reading charts & price action", "Technical indicators overview", "Fundamental market drivers", "Economic data interpretation"],
  },
  {
    number: "03",
    title: "Risk Awareness & Management",
    desc: "Learn the principles of responsible risk management &mdash; the cornerstone of any disciplined, long-term trading education.",
    topics: ["Position sizing principles", "Stop-loss strategies", "Risk-reward frameworks", "Capital preservation mindset"],
  },
  {
    number: "04",
    title: "Trading Discipline & Psychology",
    desc: "Explore the behavioral and psychological dimensions of trading, and develop the mental frameworks that support consistent, disciplined decision-making.",
    topics: ["Emotional discipline in markets", "Building a trading routine", "Avoiding common behavioral traps", "Long-term mindset development"],
  },
  {
    number: "05",
    title: "Simulation-Based Learning",
    desc: "Apply your knowledge in a risk-free simulated trading environment before engaging with live markets, building confidence through practice.",
    topics: ["Paper trading exercises", "Simulated market scenarios", "Performance review & feedback", "Iterative skill development"],
  },
  {
    number: "06",
    title: "Investor Readiness & Practical Education",
    desc: "Prepare for the next stage of your financial journey through webinars, workshops, coaching sessions, and practical investor readiness tools.",
    topics: ["Live webinars & workshops", "One-on-one coaching sessions", "Investor readiness assessment", "Cross-border market context"],
  },
];

export default function WhatYouLearn() {
  return (
    <section className="py-24 px-6 bg-white">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-14">
          <span className="inline-flex items-center gap-2 text-[#C9A961] text-xs font-semibold uppercase tracking-[0.25em] mb-4">
            <span className="w-8 h-px bg-[#C9A961]" />
            Curriculum
            <span className="w-8 h-px bg-[#C9A961]" />
          </span>
          <h2 className="font-['Cormorant_Garamond'] text-4xl md:text-5xl font-bold text-[#2B2D2F] mb-4">
            What Students Will Learn
          </h2>
          <p className="text-[#6B6B6B] text-base max-w-2xl mx-auto font-light leading-relaxed">
            Our curriculum is designed to build genuine market knowledge, not shortcuts. Each module builds on the last, creating a comprehensive foundation for long-term financial education.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {modules.map((mod) => (
            <div
              key={mod.number}
              className="border border-[#E8E4DC] rounded-lg p-8 hover:border-[#1A4D3C]/30 hover:bg-[#F8F6F3] transition-all duration-300 group"
            >
              <div className="font-['Cormorant_Garamond'] text-5xl font-bold text-[#1A4D3C]/15 group-hover:text-[#1A4D3C]/25 transition-colors mb-4 leading-none">
                {mod.number}
              </div>
              <h3 className="font-['Cormorant_Garamond'] text-2xl font-bold text-[#2B2D2F] mb-3">{mod.title}</h3>
              <p className="text-[#6B6B6B] text-sm leading-relaxed mb-5" dangerouslySetInnerHTML={{ __html: mod.desc }} />
              <ul className="space-y-2">
                {mod.topics.map((topic) => (
                  <li key={topic} className="flex items-center gap-2.5 text-xs text-[#2B2D2F]">
                    <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                      <i className="ri-arrow-right-s-line text-[#C9A961] text-sm" />
                    </div>
                    {topic}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
